import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatWidgetComponent } from './chat-widget/chat-widget.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ScrollbarModule } from 'ZalamoLibrary/src/lib/ui/scrollbar/scrollbar.module';
import { IsMePipe } from './is-me.pipe';
import { LuxonModule } from 'luxon-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'ZalamoLibrary/src/lib/ui/button/button/button.module';
import { AutofocusFixModule } from 'ZalamoLibrary/src/lib/ui/autofocus/autofocus.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgScrollbarCdkVirtualScroll } from 'ngx-scrollbar/cdk';
import { ChatAttachmentsComponent } from './chat-widget/chat-attachments/chat-attachments.component';
import { ImagesModule } from 'ZalamoLibrary/src/lib/ui/images/images.module';
import { ImageLoaderModule } from 'ZalamoLibrary/src/lib/core/image/image-loader/image-loader.module';
import { MatMenuModule } from '@angular/material/menu';
import { FullscreenImageViewerModule } from 'ZalamoLibrary/src/lib/ui/images/fullscreen-image-viewer/fullscreen-image-viewer.module';
import { ShowOnlyIfVisibleModule } from 'ZalamoLibrary/src/lib/ui/directives/show-only-if-visible/show-only-if-visible.module';
import { ParseMessagePipe } from './chat-widget/parse-message.pipe';

@NgModule({
  declarations: [ChatWidgetComponent, IsMePipe, ChatAttachmentsComponent, ParseMessagePipe],
  exports: [ChatWidgetComponent, ChatAttachmentsComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    ScrollbarModule,
    LuxonModule,
    MatTooltipModule,
    ButtonModule,
    AutofocusFixModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    NgScrollbarModule, NgScrollbarCdkVirtualScroll,
    ImagesModule,
    ImageLoaderModule,
    MatMenuModule,
    FullscreenImageViewerModule,
    ShowOnlyIfVisibleModule,
  ],
})
export class ChatModule {}
